module.exports = __webpack_public_path__ + "static/media/hero-python-one.ded961d9.jpg";